import {
  mappers,
  MenuSelect,
  NoResults,
  Pagination,
  SearchBox,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';
import { HitComponent, LoadingComponent } from '@white-nl/instantsearch-components/dist/types/components';
import { Hit, Loading } from '../components/projects/results';
import { ClearIndicator, DropdownIndicator } from '../components/ui/React-select';

const settings = document.getElementById('projects-overview')?.dataset || null;
const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
if (settings) {
  const apiUrl = Craft.getSiteUrl('api/react/projects');

      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json())
        .then((data) => {
          const {
            translates,
            categoriesSorting,
            statuses,
          } = data;

          const {
            projects,
            pagination,
          } = translates;

          const indexName = settings.indexName || '';

          whiteInstantSearchCatalog
            .withSearchkit(
              indexName,
              settings.publicUrl || '',
              settings.jwt || '',
              settings.refreshUrl || '',
            )
            .withWhiteInstantSearchRouting({
              baseUrl: settings.baseUrl,
              pathAttribute: '',
              addTrailingSlashesToUrls: Craft.trailingSlashes,
              writeDelay: 0,
            })
            .addAdditionalData({
              translates,
            })
            .addMenu(
              [{
                settings: {
                  attribute: 'categorie',
                  limit: 999,
                  sortBy: (a, b) => {
                    const positionA = categoriesSorting[a.escapedValue] || -1;
                    const positionB = categoriesSorting[b.escapedValue] || -1;

                    if (positionA > positionB) {
                      return 1;
                    }
                    if (positionA < positionB) {
                      return -1;
                    }

                    return 0;
                  },
                  classNames: {
                    control: () => 'dropdown-select',
                    menu: () => 'dropdown-list',
                  },
                  isSearchable: false,
                  isClearable: true,
                  unstyled: true,
                  components: {
                    ClearIndicator,
                    DropdownIndicator,
                  },
                  translations: {
                    defaultOptionText:  Craft.t(projects,'All Categories'),
                  },
                },
                component: MenuSelect,
              },
              ],
              '#white-instant-first-refinements',
            )
            .addMenu(
              [{
                settings: {
                  attribute: 'status',
                  transformItems: mappers.transformers.mapValues(statuses),
                  limit: 999,
                  classNames: {
                    control: () => 'dropdown-select',
                    menu: () => 'dropdown-list',
                  },
                  isSearchable: false,
                  isClearable: true,
                  unstyled: true,
                  components: {
                    ClearIndicator,
                    DropdownIndicator,
                  },
                  translations: {
                    defaultOptionText:  Craft.t(projects,'All Statuses'),
                  },
                },
                  component: MenuSelect,
                },
              ],
              '#white-instant-second-refinements',
            )
            .addSearchingComponent([
              {
                settings: {
                  placeholder: Craft.t(projects, 'Search projects'),
                },
                component: SearchBox,
              },
            ])
            .addHitComponent(
              [
                {
                  settings: {
                    noResults: {
                      translations: {
                        noResults: Craft.t(projects, 'Sorry, we can\'t find any projects!'),
                        refinements: Craft.t(projects, 'Try to choose another category or filter.'),
                        query: Craft.t(projects, 'Please try another query.'),
                      },
                    },
                  },
                  component: Hit as HitComponent,
                  loadingComponent: Loading as LoadingComponent,
                  noResultsComponent: NoResults,
                },
              ],
              '#white-instant-search-hits',
            )
            .setHitsPerPage(9)
            .addPaginationComponent([
              {
                settings: {
                  classNames: {
                    noRefinementRoot: 'hidden',
                    list: 'list-none py-8 px-0 mx-0 my-auto w-full flex flex-wrap md:justify-between items-center gap-2 md:gap-4',
                    pageItem: 'group/item cursor-pointer p-0 size-8 md:size-10 flex justify-center items-center transition-all border border-gray-600 rounded-full text-gray-600 hover:bg-green-200 hover:border-green-200 [.active]:bg-green-200 [.active]:border-green-200',
                    link: 'block w-full text-center justify-start text-xs font-medium/4 line-clamp-1 no-underline',
                    previousPageItem: 'p-0 *:text-xs *:md:text-xs *:border-none mr-auto',
                    selectedItem: 'active',
                    disabledItem: '*:pointer-events-none *:text-grey-300',
                    nextPageItem: 'p-0 text-xs *:text-gray-600 ml-auto *:border-none',
                  },
                  translations: {
                    previousPageItemText: Craft.t(pagination, 'Previous'),
                    nextPageItemText: Craft.t(pagination, 'Next'),
                  },
                  showFirst: false,
                  showLast: false,
                },
                component: Pagination,
              }])
            .setScrolling({
              includeAttributes: ['page'],
            });
          whiteInstantSearchCatalog
            .build()
            .show();
        });
}
